<template >
  <el-card v-loading="loading" >

    <div
        slot="header"
        class="clearfix" >

      <transition name="el-zoom-in-bottom" >
        <h4 v-if="RouteData" >
          <small > add/remove customes in</small >
          {{ RouteData.named_pup_seq }} on {{ RouteData.dateHuman }}
          <el-button
              style="float: left"
              type="text"
              plain
              title="stop doing that"
              @click="routeGo({ query: { selected_route: null } })" >
            <i
                class="material-icons"
                style="font-size: 12px" >remove_circle_outline</i >
          </el-button >
        </h4 >
      </transition >
    </div >
    <s-table
        ref="customer_list"
        :colDefinitions="colcustomerDefinitions"
        modx-processor="customers/getlist"
        :r-query="customersQuery"
        @cell-clicked="goToCustomer"
        :rowClassFactory="styler"
        :pagging="60"
        :simpleLazyLoader="true" ></s-table >
    <el-drawer
        :modal-append-to-body="false"
        :size="rightDrawerSize()"
        :visible.sync="showcustomer"
        direction="rtl"
        :before-close="handleClose"
        :show-close="false"
        destroy-on-close

        :withHeader="false" >
      <!-- <el-drawer
      :wrapperClosable="false"
      :size="rightDrawerSize()"
      title="Customer info"
      :visible.sync="showcustomer"
      direction="rtl"
      :before-close="handleClose"
      >-->
      <router-view
          @done="handleClose"
          @cancel="handleClose"
          @update="(e) => $emit('update', e)"
          @delete="(e) => $emit('delete', e)" ></router-view >
    </el-drawer >
    <!-- <customer-form v-model="editcustomerData"></customer-form> -->
  </el-card >
</template >

<script >
import * as api from "~/api/resource";

import {mapGetters, mapActions} from "vuex";
import {async} from "q";
import commons from "~/mixins/commons";
import STable from "../../Form/STable";

export default {
  components: {STable},
  mixins: [commons],
  async mounted() {
    var vm = this;
    // _log_("ole boo ", this.$route.params);
    if (this.$route.params.customerid)
      this.goToCustomer(this.$route.params.customerid);
    // _log_("ole boo ", REPO);
    // if (!this.rooms.length) await this.fetchRooms();
    // const bkid = this.$route.query ? this.$route.query.bkid : null;
    // if (bkid) {
    //   var { data } = await api.fetchProcessor(
    //     "customers/vuecustomer",
    //     this.$route.query
    //   );
    //   this.customer = data.results;
    // }
    // await this.fetchAvailablecustomerTags();
    // this.loadTripData();
    this.loading = false;
  },
  watch: {
    // "$route.params.tripid"(tripid, oldTrip) {
    //   if (tripid && oldTrip != tripid) this.loadTripData();
    // },
    "$route.params.customerid": async function (bkid, oldval) {
      _log_("get b oo ", bkid, oldval);
      if (!bkid) return;
      if (bkid != oldval) {
        this.showcustomer = true;
        this.goToCustomer(bkid);
        // this.loading = true;
        // var { data } = await api.fetchProcessor(
        //   "customers/vuecustomer",
        //   this.$route.query
        // );
        // this.customer = data.results;
        // this.loading = false;
      }
    },
  },
  methods: {
    styler(e) {
      if (e.row.canceled) return "canceled-row";
      return "";
    },
    async xloadTripData(id) {
      id = id ? id : this.$route.params.tripid;
      if (id)
        this.tripDada = await api.fetchObject("scheduletrip", {
          id: id,
        });
    },
    handleClose() {
      this.routeGo({
        name: "customers",
        params: {customerid: null},
      });
      this.showcustomer = false;
    },
    async goToCustomer(val) {
      const vm = this;
      if (
          val &&
          val.column &&
          (val.column.property == "tserv_title" ||
              val.column.property == "startTime")
      )
        if (this.$route.params.kind == "package") {
          this.routeGo({
            name: "customers",
            params: {tripid: val.row.strip_id},
          });
          return;
        }
      if (val && val.column && val.column.property == "registered_routes") {
        if (vm.$route.query.selected_route) {
          await api.updateProcessor("vue_route/updatebookings", {
            routename: vm.$route.query.selected_route,
            do:
                val.row.registered_routes.indexOf(
                    vm.$route.query.selected_route + ""
                ) >= 0
                    ? "remove"
                    : "add",
            customer_id: val.row ? val.row.id : null,
          });
          if (val.row.id) this.$refs.customer_list.reloadRow(val.row.id);
          else this.$refs.customer_list.reload();
        }
        return;
      }
      _log_("suggest..", val);
      if (val && val.column && val.column.property == "id") {
        //package_services
        this.routeGo({
          name: "package_services",
          params: this.$route.params,
          query: {selected_customer: val.row.id},
        });
        return;
      }
      var Q = {}; //this.$route.params
      Q.customerid = val.row ? val.row.id : val;
      _log_("hell yes", Q);
      this.routeGo({
        name: "customer",
        params: Q,
      });
      this.showcustomer = true;
    },
    async querycustomerTypes(queryString, cb) {
      var {data} = await api.fetchProcessor("gears/gettags", {
        type: "customer_customerType",
      });
      var res = [];
      if (data.results)
        data.results.forEach((element) => {
          if (element.toLowerCase()
              .indexOf(queryString.toLowerCase()) >= 0)
            res.push({value: element});
        });
      // _log_("suggest..", data);
      cb(res);
    },
  },
  data() {
    return {
      loading: true,
      errors: {},
      tripDada: null,
      showcustomer: false,
      bookedDates: [],
      editcustomerData: null,
      customers: REPO.customers,
    };
  },
  computed: {
    customersQuery() {
      _log_("go q ", this.$route.query);
      var q = {
        ...this.$route.params,
        ...this.$route.query,
        tripType: "PACKAGE",
        type: "full",
      };
      return q;
    },
    colcustomerDefinitions() {
      var rw = "580px";
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      var cols = [
        {
          prop: "id",
          width: 50,
          label: "",
          action: "button",
          // editorcomponent: {
          //   type: "date",
          //   displayFormat: "dd/MM/yyyy",
          //   is: "s-dater"
          // },
          // editable: true,
          formatter: function (val, colDefs, row, vm) {
            if (row.status == "canceled") return "";
            return '<i class="material-icons" title="Customise the activities">card_giftcard</i>';
          },
        },
        {prop: "leader", width: 180, label: "Customer Name"},
        {prop: "reference", width: 120, label: "Referense"},
        // { prop: "country", width: "", label: "Country" },
        {
          prop: "pax",
          width: 70,
          label: "PAX",
          formatter: function (val, cols, row) {
            // _log_(">>>>" + val, row);
            if (!row.comment_kids) return row.comment_adults;
            const px =
                (row.comment_adults ? +row.comment_adults : 0) +
                (row.comment_kids ? +row.comment_kids : 0) +
                ":" +
                (row.comment_adults ? row.comment_adults : "") +
                "/" +
                (row.comment_kids ? row.comment_kids : "");
            return px;
            // return "<span style='padding:3px;>"+px+"</span>"
          },
        },
        {prop: "comment_room", width: 100, label: "Rm.Type"},
        {
          prop: "comment_accommodation",

          label: "Accommodation Notes",
        },
        {prop: "comment_general", label: "General Notes"},
        {prop: "comment_activity", label: "Activity Notes"},
      ];
      if (this.$route.params.tripid == "all") {
        cols.splice(0, 1);

        cols = [
          {
            prop: "tserv_title",
            width: 180,
            label: "Package",
            clickable: true,
          },
          {
            prop: "startTime",
            width: "100px",
            clickable: true,
            label: "Date",
            formatter: function (val, colDefs, row, vm) {
              // _log_(">>>>" + val, row);
              return vm.formatDate(val);
            },
          },

          ...cols,
        ];
      }
      else if (this.$route.query && this.$route.query.selected_route)
        cols = [
          {
            prop: "registered_routes",
            width: 50,
            label: "",
            action: "button",
            formatter: function (val, colDefs, row, vm) {
              _log_(">>>>", vm.$route.query, row);

              // if (val.indexOf("c_") >= 0)
              //   if (row.singleBooking)
              //     return '<i class="material-icons">person</i>';
              //   else return '<i class="material-icons">supervisor_account</i>';
              if (val && val.indexOf(vm.$route.query.selected_route + "") >= 0)
                return '<i class="material-icons danger" title="remove this customer from this servise">indeterminate_check_box</i>';
              else
                return '<i class="material-icons"  title="add this customer to this servise">add_box</i>';
            },
          },
          ...cols,
        ];
      return cols;
    },
    datepickerOptions() {
      return {
        disabledDate: this.isBookable,
      };
    },
  },
};
</script >
